export default __webpack_public_path__ + "static/media/receivables.3d2b2c70.PNG";